<!-- 开通月卡接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"2KNTYVWC","vipTypeCode":"T99","vipTypeName":"测试月卡类型99","ticketNo":"Test99","carOwner":"张三","telphone":"18022222222","sex":"0","operator":"test","operateTime":"2017-02-28 00:00:00","originPrice":"200","favorPrice":"200","openValue":"1.00","openCarCount":"100","carList":[{"carNo":"粤AT2Q80","carLicenseType":"","carColor":"","carLogo":"","carModel":"","carType":"","carOwnType":"","carSizeType":""}],"timePeriodList":[{"startTime":"2017-02-28 00:00:00","endTime":"2017-03-31 23:59:59"}],"carportList":[{"parkingLotId":"2KKN885S","carportSerialNumber":"1","carportAlaisName":"1","carportType":"1","isOpenReserved":"1"},{"parkingLotId":"2KKN885S","carportSerialNumber":"2","carportAlaisName":"2","carportType":"2","isOpenReserved":"0"}]},
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台开通月卡",
                t_url: this.commonUrls.test+"addVipTicket",
                p_url: this.commonUrls.prod+"addVipTicket",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'vipTypeCode', info2: '否', info3: 'String', info4: 'VIP类型唯一编号' },
                        { info1: 'vipTypeName', info2: '否', info3: 'String', info4: 'VIP类型名称，如果没有对接“新增月卡类型”接口，可以在停车场管理系统预先建好VIP类型，然后按“VIP类型名称”开通VIP票' },
                        { info1: 'ticketNo', info2: '是', info3: 'String', info4: '外部系统定义的票唯一编号' },
                        { info1: 'carOwner', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'telphone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'company', info2: '否', info3: 'String', info4: '车主公司' },
                        { info1: 'sex', info2: '是', info3: 'Integer', info4: '车主性别，0男 1女 2未知' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'originPrice', info2: '是', info3: 'Decimal', info4: '票原价，单位元' },
                        { info1: 'favorPrice', info2: '是', info3: 'Decimal', info4: '票折后价，单位元' },
                        { info1: 'openValue', info2: '否', info3: 'Decimal', info4: '开通值，时间类型，填月数；余额类型，填储值，openValue和timePeriodList不能同时为空' },
                        { info1: 'openCarCount', info2: '是', info3: 'Integer', info4: '车位数' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源，(<url>参考附录:/Api/appendixData#appendixData_1</url>)' },
                        { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'Integer', info4: '支付方式，(<url>参考附录:/Api/appendixData#appendixData_0</url>)' },
                        { info1: 'carList', info2: '是', info3: 'JSONArray', info4: '车辆列表' },
                        { info1: 'timePeriodList', info2: '否', info3: 'JSONArray', info4: '有效时间段列表，openValue和timePeriodList不能同时为空；非时间类型VIP有效时间段不能为空' },
                        { info1: 'carportList', info2: '否', info3: 'JSONArray', info4: '车位列表' }
                        ]
                },{
                    titleName: 'carList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号，大写' },
                        { info1: 'carLicenseType', info2: '否', info3: 'Integer', info4: '车牌类型' },
                        { info1: 'carColor', info2: '否', info3: 'Integer', info4: '车辆颜色' },
                        { info1: 'carLogo', info2: '否', info3: 'Integer', info4: '车辆品牌' },
                        { info1: 'carModel', info2: '否', info3: 'Integer', info4: '品牌型号' },
                        { info1: 'carType', info2: '否', info3: 'Integer', info4: '车辆类型' },
                        { info1: 'carOwnType', info2: '否', info3: 'Integer', info4: '车归属类型，0未知，1公车，2私车' },
                        { info1: 'carSizeType', info2: '否', info3: 'Integer', info4: '车辆大小类型，0未知，1小车，2大车，3超大车，4中型车' }
                        ]
                },{
                    titleName: 'timePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm:ss' }
                        ]
                },{
                    titleName: 'carportList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingLotId', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carportSerialNumber', info2: '是', info3: 'String', info4: '车位编号' },
                        { info1: 'carportAlaisName', info2: '是', info3: 'String', info4: '车位别名' },
                        { info1: 'carportType', info2: '是', info3: 'int', info4: '车位类型，0未指定,1固定车位,2临时车位,3租用车位' },
                        { info1: 'isOpenReserved', info2: '是', info3: 'boolean', info4: '是否开启预订，0否，1是' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/vip/addVipTicket.vue